import { Component, OnInit, Input, ViewChild, HostListener, ChangeDetectorRef } from '@angular/core';
import { SharedService } from 'src/app/core/services/shared.service';
import Swal from 'sweetalert2';
import { SafeResourceUrl } from '@angular/platform-browser';
import { FiltrocampoInlineComponent } from '../filtrocampo-inline/filtrocampo-inline.component';

@Component({
  selector: 'app-reportes',
  templateUrl: './reportes.component.html',
  styleUrls: ['./reportes.component.scss']
})
export class ReportesComponent implements OnInit {

  index: number = 0;
  arrPDF: any[] = [];
  currentPDF: any;
  safeURL: SafeResourceUrl;
  reporteSel = null;
  tipoReporteSel = 'PDF';
  base64 = '';
  searchTerm: string = '';
  reporteActivo: boolean = false;
  

  parametros = { FILTROS_OPCIONALES: [], SYS02CON: "", SYS10CON: "", FORMATO: "PDF", TSTAMP: "", TITULO: "", FILTROS_OBLIGATORIOS: [] };

  @Input() blnMostrarBusqueda: boolean = false;
  @Input() TipoPantalla: string = '';
  @Input() strListener: string = '';
  @Input() SYS02CON: string | number = '';
  @Input() reportes = [];
  @Input() filtrosReporte = [];
  @Input() favorito_pantalla: string = '';
  @Input() AccionesOnChange = [];
  @Input() isImprimir = false;
  @Input() dashboard = { CHARTS: [] };

  @ViewChild(FiltrocampoInlineComponent) filtroCampo!: FiltrocampoInlineComponent;

  constructor(private dataService: SharedService, private cdr: ChangeDetectorRef) { }


  ngOnInit(): void {
  }

  seleccionarReporte(r: any): void {
    this.reporteActivo = false;           // destruye el hijo
    this.reporteSel = this.reporteSel === r ? null : r;
    this.base64 = '';
    if (this.reporteSel) {
      if (!this.tipoReporteSel) this.tipoReporteSel = 'PDF';
      setTimeout(() => {
        this.reporteActivo = true;
        this.cdr.detectChanges();
      }, 0); // recrea el hijo limpio
    }
  }

  seleccionarFormato(formato: string): void {
    this.tipoReporteSel = formato;
    this.obtenerReporte();
  }

  cerrarVisor(): void {
    this.base64 = '';
  }

  @HostListener('document:keydown.escape')
  onEscKey(): void {
    if (this.base64) {
      this.cerrarVisor();
    }
  }

  reportesFiltrados(): any[] {
    if (!this.searchTerm) {
      return this.reportes;
    }
    const term = this.searchTerm.toLowerCase();
    return this.reportes.filter((r: any) =>
      (r.SYS10DES || '').toLowerCase().includes(term)
    );
  }

  obtenerReporte() {
    let filtroCampos = this.filtroCampo.DemeFormulario();
    if (filtroCampos != 0) {
      if (this.tipoReporteSel != null && this.reporteSel != null) {
        this.parametros.SYS02CON = this.reporteSel.SYS02CON;
        this.parametros.SYS10CON = this.reporteSel.SYS10CON;
        this.parametros.TSTAMP = this.reporteSel.TSTAMP;
        this.parametros.FORMATO = this.tipoReporteSel;
        this.parametros.FILTROS_OPCIONALES = [filtroCampos];

        let json = this.toJSON('ABRIR_REPORTE_PDF', this.parametros, 'api/mantenimientos/VerReporte/' + this.parametros.SYS02CON + '/' + this.parametros.SYS10CON + '/' + this.parametros.TSTAMP, "");

        this.dataService.ConsultarWS('api/mantenimientos/VerReporte/' + this.parametros.SYS02CON + '/' + this.parametros.SYS10CON + '/' + this.parametros.TSTAMP, JSON.stringify(json)).subscribe((datosResp: any) => {
          if (datosResp.DATA != null) {
            if (datosResp.DATA.length > 0) {
              if (this.tipoReporteSel == 'PDF') {
                this.base64 = datosResp.DATA[0].REPORTE_PDF_BASE64;
              } else if (this.tipoReporteSel == 'XLS') {
                this.base64 = '';
                const blob = this.dataURItoBlob(datosResp.DATA[0].REPORTE_PDF_BASE64, 'XLS');
                let fileURL = URL.createObjectURL(blob);
                let link = document.createElement('a');
                link.download = 'Reporte ' + this.reporteSel.SYS10DES + '.xls';
                link.href = fileURL;
                link.click();
              }else if(this.tipoReporteSel == 'NAV'){
                const base64 = datosResp.DATA[0].REPORTE_PDF_BASE64;
                const blob = this.dataURItoBlob(base64, this.tipoReporteSel);
                let fileURL = URL.createObjectURL(blob);
                window.open(fileURL, '_blank');
              }
            }
          }

        },
        error => {
          this.base64 = '';
          Swal.fire({
            title: 'Error',
            text: error,
            icon: 'error',
          })
        });
      }
    }else{
      const camposFaltantes = this.obtenerCamposRequeridos();

      const listaHTML = camposFaltantes.length > 0
        ? `<ul style="text-align:left; margin-top:8px; padding-left:20px;">
             ${camposFaltantes.map(c => `<li><b>${c}</b></li>`).join('')}
           </ul>`
        : '';

      Swal.fire({
        html: '<div class="row align-items-center" style="width:100%; overflow:auto;">' +
          '<div class="col-4">' +
          '<img src="assets/images/imageerror.png"></div>' +
          '<div class="col-8">' +
          '<h3>Error</h3><br>' +
          '<p>Debe diligenciar los campos requeridos:</p>' +
          listaHTML +
          '</div></div>',
      });
    }
  }

  obtenerCamposRequeridos(): string[] {
    const faltantes: string[] = [];
    const filtros = this.filtrosReporte?.[0]?.FiltrosExpuestos || [];

    filtros.forEach((filtro: any) => {
      // Si el campo está oculto para este SYS10CON, no se valida
      if (this.campoEstaOculto(filtro.label)) {
        return;
      }

      if (filtro.validators?.required === true) {
        const valorActual = this.filtroCampo?.myFormGroup?.get(filtro.label)?.value;
        if (!valorActual || valorActual === '' || valorActual === null) {
          faltantes.push(filtro.title || filtro.label);
        }
      }
    });

    return faltantes;
  }

  private campoEstaOculto(label: string): boolean {
    if (!this.reporteSel || !this.AccionesOnChange?.length) return false;
    const sys10conActual = String(this.reporteSel.SYS10CON);

    return this.AccionesOnChange.some((accion: any) => {
      if (accion.Campo !== 'SYS10CON' || accion.OcultarDestino !== 'S') return false;
      const valores = String(accion.Valores).split(',').map(v => v.trim());
      return valores.includes(sys10conActual) && accion.Destino === label;
    });
  }

  reiniciarFormulario(){
    this.base64 = '';
    this.filtroCampo.reiniciarFormulario();
  }

  toJSON(operacion: string, arr: any, url?: string, extra?: string) {
    let jsonReturn = { TITULO: "Reporte Nav", URL: "", EXTRA: "", OPERACION: null, LLAVES: null };
    jsonReturn.LLAVES = arr;
    if (url != null) {
      jsonReturn.URL = url;
    }
    if (extra != null) {
      jsonReturn.EXTRA = extra;
    }
    jsonReturn.OPERACION = operacion;

    return jsonReturn;
  }

  dataURItoBlob(dataURI, strFORMATO, strType = "application/pdf") {
    if (strFORMATO == "XLS") { strType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    console.log('strType', strType);
    
    const blob = new Blob([int8Array], { type: strType });
    return blob;
  }

  GrabarFavorito() {
    if (this.favorito_pantalla == "N") {
      this.EventoWsInsert();
    } else {
      this.EventoWsDelete();
    }
  }


  EventoWsInsert() {
    this.dataService.ConsultarWS('api/mantenimientos/Favoritos/ADD/' + this.reporteSel.SYS02CON).subscribe(
      (datosResp: any) => {
        // almora 202.03.21 No necesito recargar la página
        this.favorito_pantalla = "S";
        Swal.fire({
          position: 'bottom-end',
          toast: true,
          icon: 'success',
          text: 'Dato Grabado exitosamente',
          showConfirmButton: false,
          timer: 5000
        });
      },
      error => {
        Swal.fire({
          title: 'Error',
          text: error,
          icon: 'error',
        })
      });
  }

  EventoWsDelete() {
    this.dataService.ConsultarWS('api/mantenimientos/Favoritos/DEL/' + this.reporteSel.SYS02CON).subscribe(
      (datosResp: any) => {
        // almora 202.03.21 No necesito recargar la página
        this.favorito_pantalla = "N";
        Swal.fire({
          position: 'bottom-end',
          toast: true,
          icon: 'success',
          text: 'Dato Eliminado exitosamente',
          showConfirmButton: false,
          timer: 5000
        });
      },
      error => {
        Swal.fire({
          title: 'Error',
          text: error,
          icon: 'error',
        })
      });

  }
}
